module.exports = "/shared/img/fast-ticket-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-ticket-bck.png
// module id = 42
// module chunks = 13